import type { StateCreator } from "zustand";
import type { nagwaRenderEngineSlice } from "../../interfaces/slicesInterfaces/nagwaRenderEngineSlice";
import type { SessionChatMessage } from "../../interfaces/sessionChatMessage";

export const createNagwaRenderEngineSlice: StateCreator<
  nagwaRenderEngineSlice,
  [],
  [],
  nagwaRenderEngineSlice
> = (set, _get) => ({
  isEngineLoaded: false, 
  
  setIsEngineLoaded: (loaded: boolean) =>
    set(() => ({
      isEngineLoaded: loaded,
    })),
    
  engineError: null,
  setEngineError: (error: string | null) =>
    set(() => ({
      engineError: error,
    })),

  // Screen data management
  screenData: [],
  setScreenData: (screens) =>
    set(() => ({
      screenData: screens,
    })),
  addScreen: (screen) =>
    set((state) => ({
      screenData: [...state.screenData, screen],
    })),

  // Joined students management
  joinedStudents: [],
  addStudent: (user) =>
    set((state) => {
      // Only add if user doesn't already exist
      const userExists = state.joinedStudents.some(u => u.userId === user.userId);
      if (userExists) { 
        return state;
      } 
      return {
        joinedStudents: [...state.joinedStudents, user],
      };
    }),
  removeStudent: (userId: string) =>
    set((state) => {
      // Only remove if user exists
      const userExists = state.joinedStudents.some(u => u.userId === userId);
      if (!userExists) { 
        return state;
      } 
      return {
        joinedStudents: state.joinedStudents.filter((u) => u.userId !== userId),
      };
    }),

  // Chat management
  chatMessages: [],
  addChatMessage: (message: SessionChatMessage) =>
    set((state) => ({
      chatMessages: [...state.chatMessages, message],
    })),

  // CENTRALIZED ENGINE COMMUNICATION
  // All postMessage calls to the engine go through here
  sendMessageToEngine: (action: string, payload: any) => {
    console.log(`[NagwaEngine] Attempting to send ${action} to engine:`, payload);
    const engineBasePath = import.meta.env.VITE_ENGINES_BASE_PATH;
    if (!engineBasePath) {
      console.warn('[NagwaEngine] VITE_ENGINES_BASE_PATH not configured');
      set({ engineError: 'Engine base path not configured' });
      return;
    }

    try {
      // Use the same origin calculation as in NagwaRenderingEngine component
      const iframeSrc = `${engineBasePath}/html_rendering_engine/index.html`;
      const iframeOrigin = new URL(iframeSrc).origin;
      console.log('[NagwaEngine] Target origin:', iframeOrigin);

      const message = {
        engineName: "NagwaRenderingEngine",
        action,
        payload,
      };

      // Find the engine iframe
      const iframe = document.querySelector('iframe[title="Nagwa Rendering Engine"]') as HTMLIFrameElement;
      console.log('[NagwaEngine] Found iframe:', iframe);

      if (iframe?.contentWindow) {
        console.log('[NagwaEngine] Sending message to iframe contentWindow');
        iframe.contentWindow.postMessage(JSON.stringify(message), iframeOrigin);
        console.log(`[NagwaEngine] ${action} sent successfully`);
      } else {
        console.warn('[NagwaEngine] Engine iframe not found or no contentWindow');
        console.log('[NagwaEngine] Iframe element:', iframe);
        console.log('[NagwaEngine] Iframe contentWindow:', iframe?.contentWindow);
        set({ engineError: 'Engine iframe not found' });
      }
    } catch (error) {
      console.error(`[NagwaEngine] Failed to send ${action}:`, error);
      set({ engineError: `Failed to send ${action}` });
    }
  }

});